import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
const breeds = [{
  name: 'Perro Salchicha',
  image: 'https://cdn.magicpatterns.com/uploads/tHNVv6oTcMw17BZLFwZC4m/20260225_1912_Image_Generation_simple_compose_01kjbdrg11ewxv6nnar0hhycrv.png'
}, {
  name: 'Golden Retriever',
  image: 'https://cdn.magicpatterns.com/uploads/b9BgAzEgP28dc51cG1G2sA/20260225_1918_Image_Generation_simple_compose_01kjbe3ewcfnxsyah3g5mv1z4c.png'
}, {
  name: 'Bulldog Francés',
  image: 'https://cdn.magicpatterns.com/uploads/55b2iNVqzWDzqX8toVHuot/20260225_1913_Hyper-Realistic_Crochet_Bulldog_simple_compose_01kjbds9qgfcbtgtwstnejfp5f.png'
}, {
  name: 'Labrador',
  image: 'https://cdn.magicpatterns.com/uploads/hwHXWAX3P3qdPFW1hoo3zQ/20260225_1922_Image_Generation_simple_compose_01kjbe9d6ffaj9xrezyw03e6eb.png'
}, {
  name: 'Poodle / Caniche',
  image: 'https://cdn.magicpatterns.com/uploads/shtbGzu9Ajxg9KVdWaJhXQ/20260225_1921_Crochet_Poodle_Amigurumi_simple_compose_01kjbe8cnbfgwadkdw1cchy9ra.png'
}, {
  name: 'Chihuahua',
  image: 'https://cdn.magicpatterns.com/uploads/dsth7uWr1NUkx3sij4CJ3F/20260225_1921_Crochet_Chihuahua_Close-up_simple_compose_01kjbe83azfqzsx9jrh4af0b0d.png'
}, {
  name: 'Husky Siberiano',
  image: 'https://cdn.magicpatterns.com/uploads/m7dv2EHVdS6tDxXwrjNPFK/20260225_1921_Crochet_Husky_Replica_simple_compose_01kjbe7mgeefkaachbvxg1ecsx.png'
}, {
  name: 'Pastor Alemán',
  image: 'https://cdn.magicpatterns.com/uploads/w9wybYXLmfqGZYauSZP51a/20260225_1920_Amigurumi_Shepherd_Duo_simple_compose_01kjbe79bcf5yt4dnvm4ccx6as.png'
}, {
  name: 'Dálmata',
  image: 'https://cdn.magicpatterns.com/uploads/8yA7dNoxkA97ajkgmtmARA/20260225_2056_Image_Generation_simple_compose_01kjbkpzjremsrmhg08xgn0pwb.png'
}, {
  name: 'Dóberman',
  image: 'https://cdn.magicpatterns.com/uploads/x7kC7f5r75LvZLtj7xf1UK/20260225_2122_Image_Generation_remix_01kjbn656pffksrqbh5sf0vwwt_(1).png'
}, {
  name: 'Gato Siamés',
  image: 'https://cdn.magicpatterns.com/uploads/vRPnfLCuPDxBbhBoD2e6MP/20260225_2052_Image_Generation_simple_compose_01kjbkedwff66b2wbh1nh7bz3c.png'
}, {
  name: 'Gato Persa',
  image: 'https://cdn.magicpatterns.com/uploads/gE9cvjdp4GVDaJtQbqmRdb/hf_20260225_221856_c993e774-758d-450e-8df0-f435a44a3a53.jpg'
}];
export function BreedGallery() {
  return <section id="galeria" className="py-10 md:py-16 bg-linen" data-id="element-41">
      <div className="max-w-6xl mx-auto px-4" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-43">
          <span className="text-copper font-bold tracking-[0.2em] text-sm uppercase" data-id="element-44">
            ¿Qué encontrarás en este ebook?
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown mt-3 mb-4" data-id="element-45">
            <span className="text-terracotta" data-id="element-46">+60 patrones</span> organizados
            por raza
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto" data-id="element-47">
            Razas de perros y gatos con patrones detallados. Cada uno diseñado
            para{' '}
            <span className="text-teal font-semibold" data-id="element-48">
              capturar los rasgos únicos de cada mascota
            </span>
            . Aquí algunas de las razas incluidas:
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-id="element-49">
          {breeds.map((breed, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.04
        }} className="group cursor-pointer" data-id="element-50">
              <div className="etsy-card etsy-card-hover overflow-hidden" data-id="element-51">
                {'image' in breed && breed.image ? <div className="aspect-square overflow-hidden relative" data-id="element-52">
                    <img src={breed.image} alt={`Amigurumi ${breed.name}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-53" />
                    <div className="absolute top-3 right-3 bg-white/90 p-1.5 rounded-full shadow-sm opacity-0 group-hover:opacity-100 transition-all duration-300" data-id="element-54">
                      <Heart size={14} className="text-terracotta fill-terracotta" data-id="element-55" />
                    </div>
                  </div> : <div className={`aspect-square bg-gradient-to-br ${'color' in breed ? breed.color : 'from-gray-100 to-gray-50'} flex items-center justify-center relative`} data-id="element-56">
                    <span className="text-deep-brown/10 font-heading text-5xl font-bold select-none" data-id="element-57">
                      {breed.name.charAt(0)}
                    </span>
                    <div className="absolute top-3 right-3 bg-white/90 p-1.5 rounded-full shadow-sm opacity-0 group-hover:opacity-100 transition-all duration-300" data-id="element-58">
                      <Heart size={14} className="text-terracotta fill-terracotta" data-id="element-59" />
                    </div>
                  </div>}
                <div className="p-3 text-center" data-id="element-60">
                  <h3 className="font-bold text-deep-brown text-sm group-hover:text-copper transition-colors" data-id="element-61">
                    {breed.name}
                  </h3>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-10 text-center" data-id="element-62">
          <p className="text-copper font-bold text-sm mb-1" data-id="element-63">Y muchas más...</p>
          <p className="text-sm text-gray-400 italic" data-id="element-64">
            * Todos los patrones incluyen instrucciones para adaptar colores y
            manchas para que cuando lo vean digan: "¡Es igualito!"
          </p>
        </motion.div>
      </div>
    </section>;
}